import { CSSObject } from '@emotion/react'

export const reactionButtonOverrides: CSSObject = {
  blockSize: 27,
  '&.icon-only': {
    paddingInline: 4,
  },
}

export const emojiInputButtonOverrides: CSSObject = {
  blockSize: 28,
  '&.icon-only': {
    paddingInline: 6,
  },
}
